import {
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from '@chakra-ui/react';
import { useMsal } from '@azure/msal-react';
import RRDInventoryPage from '../RRDInventory/RRDInventoryPage';
import ArchivedRRDInventoryPage from '../RRDInventory/ArchivedRRDInventoryPage';
import FailedRRDInventoryPage from '../RRDInventory/FailedRRDInventoryPage';

import React, { useState } from 'react';

export default function RRDInventoryNav({
  setTabIndex,
}: {
  setTabIndex: any;
}) {

  const { accounts } = useMsal();
  const userdetails = JSON.parse(localStorage.getItem('userdetails') || '{}');
  const components = userdetails[0]?.components || [];

  const [tabIndex, setLocalTabIndex] = useState(0);

  const tabs = [
    { name: "RRD Inventory", component: "RRDInventory", content: <RRDInventoryPage setTabIndex={setTabIndex} isActive={tabIndex === 1}/> },
    { name: "Archived RRD Inventory", component: "ArchivedRRDInventory", content: <ArchivedRRDInventoryPage setTabIndex={setTabIndex}   isActive={tabIndex === 1}/> },
    { name: "Failed Inventory", component: "FailedRRDInventory", content: <FailedRRDInventoryPage setTabIndex={setTabIndex}  isActive={tabIndex === 1} /> },
  ];

  // Filter tabs based on the components available in userdetails
  const accessibleTabs = tabs.filter((tab) =>
    components.includes(tab.component)
  );

  const handleTabsChange = (index: number) => {
    setLocalTabIndex(index);
    setTabIndex(index);
  };

  return (
    <>
      <Tabs mt={2} index={tabIndex} onChange={handleTabsChange}>
        <TabList>
          {accessibleTabs.map((tab, index) => (
            <Tab key={index}>{tab.name}</Tab>
          ))}
        </TabList>
        <TabPanels mt={4}>
          {accessibleTabs.map((tab, index) => (
            <TabPanel key={index} p={0}>
              {React.cloneElement(tab.content, { isActive: tabIndex === index })}
            </TabPanel>
          ))}
        </TabPanels>
      </Tabs>
    </>
  );
}
